<div class="grid">
    <div class="column1">
        <ul class="list-results">
            <h2>Authors</h2>
            <li>
                <div *ngIf="!authorService.keepFocus">
                    <button (click)="addAuthor()">+ Add New Author</button>
                </div>
            </li>

            <li *ngFor="let author of allAuthors | async">
                <div *ngIf="author == authorService.selectedAuthor; else notSelected">
                    <span class="selected" (click)="selectAuthor(author)">{{author.lastName}}, {{author.firstName}}</span>
                </div>
                <ng-template #notSelected>
                    <div *ngIf="!authorService.keepFocus">
                        <button (click)="selectAuthor(author)">{{author.lastName}}, {{author.firstName}}</button>
                    </div>
                </ng-template>
            </li>
        </ul>
    </div>

    <div class="seperator-line"></div>

    <div class="column2">
        <ng-container *ngIf="authorService.selectedAuthor">
            <app-selected-author [selectedAuthor]="authorService.selectedAuthor"> </app-selected-author>
        </ng-container>
        <ng-container *ngIf="authorService.addingNewAuthor">
            <app-new-author></app-new-author>
        </ng-container>
    </div>
</div>